import React from "react";
import { useState, useEffect } from "react";
import { Transition } from "@headlessui/react";
import LazyLoad from "react-lazy-load";
import { ImageModule } from "./ImageModule";
import "../Residences/Residences.css";

export default function IndexItem({
    name,
    project,
    year,
    des,
    src,
    id,
    showProject = false,
    onShow,
}) {
    const [isShown, setIsShown] = useState(null);
    const [activeIndex, setActiveIndex] = useState(-1);
    const [loadedImages, setLoadedImages] = useState(new Set());
    const [imagesLoaded, setImagesLoaded] = useState(false);
    const isVideo = src[1]?.url.includes("mp4");

    // Preload all images when project is about to be shown
    useEffect(() => {
        if (showProject && !imagesLoaded && src) {
            const imagePromises = src
                .filter((item) => item?.url && !item.url.includes("mp4"))
                .map((item) => {
                    return new Promise((resolve, reject) => {
                        const img = new Image();
                        img.onload = resolve;
                        img.onerror = reject;
                        img.src = item.url;
                    });
                });

            Promise.all(imagePromises)
                .then(() => {
                    setImagesLoaded(true);
                })
                .catch(() => {
                    // Even if some fail, mark as loaded to show what we have
                    setImagesLoaded(true);
                });
        }
    }, [showProject, src, imagesLoaded]);
    return (
        <>
            <ImageModule
                data={activeIndex}
                activeIndex={activeIndex}
                setActiveIndex={setActiveIndex}
                isShown={isShown}
                setIsShown={setIsShown}
                page={"prod"}
            />
            <section className="index" key={project}>
                <div className="index-container">
                    <div className="index-wrapper">
                        <ul className="index-items">
                            <li
                                className="index-item"
                                onClick={() => {
                                    onShow(id);
                                }}
                            >
                                {showProject ? (
                                    <h3 className="index-item-arrow">↳</h3>
                                ) : (
                                    <h3 className="index-item-arrow">→</h3>
                                )}
                                <div className="index-preview-container">
                                    <LazyLoad>
                                        {isVideo ? (
                                            <video
                                                className="index-preview-pic"
                                                alt={project}
                                                src={src[1]?.url}
                                                playsInline
                                                autoPlay
                                                loop
                                                muted
                                            />
                                        ) : (
                                            <img
                                                className="index-preview-pic"
                                                alt={project}
                                                src={src[1]?.url}
                                            />
                                        )}
                                    </LazyLoad>
                                </div>
                                <div className="index-item-info">
                                    <h3 className="index-item-name">{name}</h3>
                                </div>
                                <div className="index-item-info">
                                    <h3 className="index-item-project">
                                        {project}
                                    </h3>
                                </div>
                                <div className="index-item-info">
                                    <h3 className="index-item-year">{year}</h3>
                                </div>
                            </li>
                            <section>
                                <Transition
                                    show={showProject}
                                    className="text-image-grid"
                                    enterFrom="opacity-0"
                                    enterTo="opacity-100"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                >
                                    <div className="text-image-grid active">
                                        <div className="text-grid">
                                            {des.map((block, blockIndex) => (
                                                <p
                                                    key={blockIndex}
                                                    style={{
                                                        whiteSpace: "pre-line",
                                                    }}
                                                >
                                                    {block.content?.map(
                                                        (node, nodeIndex) => {
                                                            // Simple text node
                                                            if (
                                                                node.nodeType ===
                                                                    "text" ||
                                                                !node.nodeType
                                                            ) {
                                                                return (
                                                                    <React.Fragment
                                                                        key={
                                                                            nodeIndex
                                                                        }
                                                                    >
                                                                        {
                                                                            node.value
                                                                        }
                                                                    </React.Fragment>
                                                                );
                                                            }

                                                            // Hyperlink node
                                                            if (
                                                                node.nodeType ===
                                                                    "hyperlink" &&
                                                                node.data?.uri
                                                            ) {
                                                                const linkText =
                                                                    node.content
                                                                        ?.map(
                                                                            (
                                                                                c
                                                                            ) =>
                                                                                c.value
                                                                        )
                                                                        .join(
                                                                            ""
                                                                        ) ||
                                                                    node.data
                                                                        .uri;

                                                                return (
                                                                    <a
                                                                        key={
                                                                            nodeIndex
                                                                        }
                                                                        href={
                                                                            node
                                                                                .data
                                                                                .uri
                                                                        }
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        {
                                                                            linkText
                                                                        }
                                                                    </a>
                                                                );
                                                            }

                                                            return null;
                                                        }
                                                    )}
                                                </p>
                                            ))}
                                        </div>
                                        <div className="image-grid">
                                            {src.map((data, index) => {
                                                const isVideo =
                                                    data?.url.includes("mp4");
                                                return (
                                                    <LazyLoad
                                                        key={`index-item-${index}`}
                                                        className="fade-wrapper"
                                                    >
                                                        {isVideo ? (
                                                            <video
                                                                className="index-item-pics img-fade loaded"
                                                                alt={project}
                                                                src={data?.url}
                                                                playsInline
                                                                autoPlay
                                                                loop
                                                                muted
                                                                onClick={() => {
                                                                    setIsShown(
                                                                        true
                                                                    );
                                                                    setActiveIndex(
                                                                        {
                                                                            url: data.url,
                                                                            name: name,
                                                                            project:
                                                                                project,
                                                                            year: year,
                                                                        }
                                                                    );
                                                                }}
                                                            />
                                                        ) : (
                                                            <img
                                                                className={`index-item-pics img-fade ${
                                                                    loadedImages.has(
                                                                        index
                                                                    )
                                                                        ? "loaded"
                                                                        : ""
                                                                }`}
                                                                alt={project}
                                                                src={data?.url}
                                                                loading="eager"
                                                                onLoad={() => {
                                                                    setLoadedImages(
                                                                        (
                                                                            prev
                                                                        ) => {
                                                                            const next =
                                                                                new Set(
                                                                                    prev
                                                                                );
                                                                            next.add(
                                                                                index
                                                                            );
                                                                            return next;
                                                                        }
                                                                    );
                                                                }}
                                                                onClick={() => {
                                                                    setIsShown(
                                                                        true
                                                                    );
                                                                    setActiveIndex(
                                                                        {
                                                                            url: data.url,
                                                                            name: name,
                                                                            project:
                                                                                project,
                                                                            year: year,
                                                                        }
                                                                    );
                                                                }}
                                                            />
                                                        )}
                                                    </LazyLoad>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </Transition>
                            </section>
                        </ul>
                    </div>
                </div>
                <br />
            </section>
        </>
    );
}
